/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "tndaccountpingapi",
            "endpoint": "https://pxvlnytwe0.execute-api.us-east-2.amazonaws.com/demo",
            "region": "us-east-2"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://dpd3ss4dye.execute-api.us-east-2.amazonaws.com/demo",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2oqbj3o73zbrviyp3tkvqskpfy.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kxu6u3lkxzardnhorqffttjtpu",
    "aws_cognito_identity_pool_id": "us-east-2:9531b069-0cc2-4143-84f2-6073bd66528a",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_HHkFRnxqS",
    "aws_user_pools_web_client_id": "76e1btv7nttcggk7jvgqp2um02",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
